module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lvAlh"))).then(() => parcelRequire('1iHdE'));